// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1744":"82421927","3575":"ce044c50","4262":"82421927","4935":"08d55499","5325":"82421927","6782":"82421927"}[chunkId] + ".chunk.css";
};